export const ACTION_TYPES = {
    POD: {
        SAVED: 'POD_SAVED'
    },
    LINK_RECORD: 'LINK_RECORD',
    INPUT: 'INPUT',
    ADD_RECORD: 'ADD_RECORD'
};

export const COLORS = {
    WHITE: '#ffffff',
    TEALISH: '#2ba0aa',
    DARK: '#282c39',
    CHARCOAL: '#3d414d'
};

export const TYPES = {
    RECORD: 'record'
};



// WEBPACK FOOTER //
// ./src/constants.js